'use client';
import classNames from 'classnames';
import { saveAICookieForShopify, saveCookieForShopify } from 'eco-design-micro/common/CookieForShopify';
import EcoStat from 'eco-design-micro/EcoStat';
import { DataLayerProps } from 'eco-design-micro/props/DataLayerProps';
import { LinkProps } from 'eco-design-micro/props/LinkProps';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import './index.scss';

const uaEventName = 'uaEvent';
// 触发埋点
const handleGTM = (params: DataLayerProps | DataLayerProps[], href: string, locale: string) => {
    if (Array.isArray(params)) {
        params.forEach((v) => gtm.push(v));
    } else if (params) {
        gtm.push({
            event: uaEventName,
            __is_shopify_href: (href || '').includes(`${locale}.ecoflow.com`),
            ...params,
        });
    }
};
// 设置标签的 target
const setTargetHandle = (target: string, href: string) => {
    if (target) {
        return target;
    }
    const isWebsite = href?.includes?.('www.ecoflow.com'); //品牌官网链接
    const isHomeBattery = href?.includes?.('homebattery.ecoflow.com'); //家储官网链接
    const isNotStartWithHttp = href?.startsWith?.('http'); //非 http 开头的,都以 _self 打开
    if (isWebsite || isHomeBattery || !isNotStartWithHttp) {
        return '_self';
    }
    return '_blank'; //新开tab页
};

/**
 * 通用链接
 *
 * 不会自动添加 locale
 *
 * 会触发埋点
 */
export default function EcoLink({
    href,
    target = '',
    className,
    stopPropagation = false,
    preventDefault = false,
    dataLayer,
    onClick,
    children,
    style,
    title,
    ...rest
}: LinkProps) {
    const prefixCls = `eco-link`;
    const { locale = 'us' } = getLocal();
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    // 打开标签的方式
    const target2 = setTargetHandle(target || '', href || '');
    // 点击事件
    const clickHandle = (e: any) => {
        // 阻止冒泡
        if (stopPropagation) {
            e.stopPropagation();
        }
        // 阻止默认行为
        if (preventDefault) {
            e.preventDefault();
        }
        // AI cookie需在 datalayer 之前
        saveAICookieForShopify(href, locale);

        // 触发埋点
        if (dataLayer) {
            handleGTM(dataLayer, href || '', locale);
        }
        // 记录用户下一个页面
        EcoStat.leavePageFromPathname(href);
        try {
            saveCookieForShopify(href, locale);
        } catch (error) {
            /* empty */
        }
        // click跳转之后的不执行 需放在最后
        if (onClick) {
            onClick(e); //触发回调
        }
    };
    const targetHref = href;

    if (!href) {
        let dataBtnId = null;
        try {
            if (rest) {
                dataBtnId = (rest as any)['data-btn-id'] || undefined;
            }
        } catch (error) {}

        return (
            <div className={classes} onClick={clickHandle} style={style} data-btn-id={dataBtnId}>
                {children}
            </div>
        );
    }
    //const hrefForShopify = addParamsToLink(href || undefined, locale);
    return (
        <a href={targetHref} className={classes} onClick={clickHandle} style={style} target={target2} {...rest}>
            {children}
        </a>
    );
}
